<template>
  <el-container class="h-screen w-screen">
    <Sidebar />
    <el-container>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { Container, Main } from "element-ui";
import Sidebar from "@/components/Sidebar";

export default {
  name: "main",
  components: {
    Sidebar,
    Container,
    Main
  }
};
</script>

<style>
.el-main {
  padding: 3rem !important;
}
</style>
